import React, { memo, useMemo, useEffect, useState } from 'react';
import TriggerViewCard from '@gp/components/TriggerViewCard';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import Table from '@gp/components/GeneralTable';
import Filter from './components/Filter';
import { FILE_TYPES2, FILE_TYPES_MAP } from '@gp/constants/const';
import { FilterItemType } from '@gp/components/GeneralSelectFilter';
import { SortBy } from 'tea-component/lib/table/addons';
import { TableListOptionsType } from '@gp/components/GeneralTable/index.d';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
import './index.scss';

interface InDevelopmentCardPropsType {
  tableClassName: string;
  title: JSX.Element | null;
  filterLoading: boolean;
  filterOptions: FilterItemType[];
  filterChange:
    | ((studio: string[], project: string[], handleFilterName: string) => void)
    | null;
  reRenderTable: boolean;
  tableLoading: boolean;
  tableOptions: TableListOptionsType | null;
  tableRecords: any; // 数组每一项要有uniqueId
  onTableSort: ((v: SortBy<any>) => void) | null;
  downloadParams: {
    select_id: string[];
    order: 'desc' | 'asc' | undefined;
    order_metric: string;
  } | null;
  downloadServices: any;
  downloadLogKey: {
    csv: string;
    excel: string;
  } | null;
  bordered: boolean | "all" | undefined
}

const DEFAULT_PROPS: InDevelopmentCardPropsType = {
  tableClassName: '',
  title: null,
  filterLoading: true,
  filterOptions: [],
  filterChange: null,
  reRenderTable: false,
  tableLoading: true,
  tableOptions: null,
  tableRecords: null,
  onTableSort: null,
  downloadParams: null,
  downloadServices: null,
  downloadLogKey: null,
  bordered:'all'
};

const InDevelopmentCard: React.FC<InDevelopmentCardPropsType> = (props) => {
  const {
    tableClassName,
    title,
    filterLoading,
    filterOptions,
    filterChange,
    reRenderTable,
    tableLoading,
    tableOptions,
    tableRecords,
    onTableSort,
    downloadParams,
    downloadServices,
    downloadLogKey,
    bordered,
  } = props;

  const { isDownloading, handleDownload } = useDownload({
    csvDownloadLogKey: downloadLogKey?.csv || '',
    excelDownloadLogKey: downloadLogKey?.excel || '',
    downloadService: createDownloadService(downloadServices),
  });

  const [triggerFoldExpand, settriggerFoldExpand] = useState<boolean>(false);
  const getChange = () => {
    settriggerFoldExpand((prevFoo) => {
      return !prevFoo;
    });
  };
  useEffect(() => {
    // 展开最后一项时，往右滚动到最右边，让用户知道后面还有展开的列，增强用户体验
    if (triggerFoldExpand) {
      const t = setTimeout(() => {
        const tableBodyEl: any = document.querySelector(
          `.${tableClassName} .tea-table__body`,
        );
        if (tableBodyEl) {
          const currentWidth = tableBodyEl.offsetWidth,
            scrollLeft = tableBodyEl.scrollLeft,
            scrollWidth = tableBodyEl.scrollWidth;
          // 出现滚动条时，此时自动向右滚动到最右边
          if (scrollWidth - currentWidth > 0) {
            tableBodyEl.scrollLeft = scrollWidth - currentWidth;
          }
        }
        clearTimeout(t);
      }, 200);
    } else {
      const t = setTimeout(() => {
        const tableBodyEl: any = document.querySelector(
          `.${tableClassName} .tea-table__body`,
        );
        if (tableBodyEl) {
          tableBodyEl.scrollLeft = 0;
        }
        clearTimeout(t);
      }, 200);
    }
  }, [triggerFoldExpand]);

  const tabs = useMemo(() => {
    return [
      {
        id: 'download',
        label: (
          <GeneralDownloadBtn
            uiType="2"
            fileTypes={FILE_TYPES2}
            isLoading={isDownloading}
            onConfirm={(payload) => {
              const fileType = payload?.fileType || FILE_TYPES_MAP.CSV;
              handleDownload({
                ...downloadParams,
                fileType,
                file_type: Number.parseInt(fileType, 10),
              });
            }}
          />
        ),
        component: (
          <div className="dbg-studio-monthly-report-in-development-card-body">
            <Filter
              loading={filterLoading}
              options={filterOptions}
              onChange={filterChange}
              triggerFoldExpand={triggerFoldExpand}
              getState={getChange}
            />
            <Table
              triggerFoldExpand={triggerFoldExpand}
              key={reRenderTable}
              className={tableClassName}
              loading={tableLoading}
              tableOptions={tableOptions}
              tableRecords={tableRecords}
              onSort={onTableSort}
              isTableBodyMaxH={false}
              bordered={bordered}
            />
          </div>
        ),
      },
    ];
  }, [
    tableClassName,
    reRenderTable,
    tableLoading,
    filterLoading,
    triggerFoldExpand,
    isDownloading,
    downloadParams,
    handleDownload,
  ]);

  return (
    <TriggerViewCard
      className="dbg-studio-monthly-report-in-development-card"
      title={title}
      loading={false}
      isNoData={false}
      tabs={tabs}
      defaultActiveId="download"
    />
  );
};

InDevelopmentCard.defaultProps = DEFAULT_PROPS;

export default memo(InDevelopmentCard);
